export const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
